import type { Catalog } from "../../en";

/** Filipino: platform admin shared strings (mirrors en). */
export const common: Catalog["adminScreens"]["common"] = {
  maintenanceOn: "Naka-ON ang maintenance mode.",
  maintenanceBody: "Read-only ang mga tenant console hangga't hindi ito pinapatay.",
  maintenanceManage: "Pamahalaan",
  readOnlyRole: "Read-only para sa iyong role",
  loadError: "Hindi ma-load ang page na ito.",
  loadErrorBody: "Tingnan ang iyong koneksyon at subukan ulit. Walang nabago.",
  sectionError: "Hindi ma-load ang bahaging ito.",
  saving: "Sine-save…",
  saved: "Na-save ang mga pagbabago",
  saveChanges: "I-save ang mga pagbabago",
  reset: "I-reset",
  cancel: "Kanselahin",
  close: "Isara",
  done: "Tapos na",
  edit: "I-edit",
  remove: "Alisin",
  export: "I-export",
  exportQueued: "Naka-queue ang export — makakatanggap ka ng email kapag handa na",
  copyId: "Kopyahin ang ID",
  copied: "Nakopya sa clipboard",
  viewAll: "Tingnan lahat",
  search: "Maghanap",
  actions: "Mga aksyon",
  moreActions: "Iba pang aksyon",
  none: "Wala",
  unlimited: "Walang limit",
  notSet: "Hindi naka-set",
  yes: "Oo",
  no: "Hindi",
  enabled: "Naka-on",
  disabled: "Naka-off",
  perMonth: "/buwan",
  perYear: "/taon",
  usdApprox: "≈ {{php}}",
  required: "Kailangan",
  typeToConfirm: "I-type ang {{value}} para kumpirmahin",
  confirmMismatch: "Hindi tugma.",
  impersonate: {
    action: "Mag-impersonate",
    title: "Mag-impersonate sa {{tenant}}",
    description: "Buksan ang tenant console bilang Admin ng workspace na ito. Naka-log ang session at ie-email ang owner pagkatapos.",
    reason: "Dahilan",
    reasonPlaceholder: "hal. Ipinasuri ng customer kung bakit mali ang sagot tungkol sa presyo",
    reasonHint: "Hindi bababa sa 10 character. Makikita sa audit log ng tenant.",
    reasonTooShort: "Maglagay ng dahilan na hindi bababa sa 10 character.",
    ticket: "Ticket #",
    ticketPlaceholder: "hal. T-1042",
    ticketRequired: "Mag-link ng support ticket.",
    readOnly: "Read-only mode",
    readOnlyHint: "Harangin ang pag-save, pag-upload, pag-delete at mga papalabas na mensahe.",
    readOnlyForced: "Read-only lang ang impersonation para sa iyong role.",
    duration: "Tagal",
    minutes: "{{count}} minuto",
    durationHint: "Hanggang {{max}} minuto ayon sa Platform settings → Security.",
    start: "Simulan ang session",
    started: "Nagsimula ang impersonation · nabuksan ang console sa bagong tab",
    writeWarning: "Naka-on ang write access — ikaw ang mananagot sa bawat pagbabago",
    popupBlocked: "Hinarang ng browser ang bagong tab.",
    openConsole: "Buksan ang tenant console",
  },
  changePlan: {
    action: "Palitan ang plan",
    title: "Palitan ang plan · {{tenant}}",
    description: "Piliin ang plan na lilipatan ng workspace na ito. Magbabago ang mga limit kasama ng plan.",
    current: "Kasalukuyan",
    custom: "Custom",
    effective: "Epektibo",
    now: "Agad (prorate)",
    renewal: "Sa susunod na billing date",
    submit: "Palitan ang plan",
    done: "Napalitan ang plan sa {{plan}}",
    limits: "{{messages}} mensahe · {{agents}} agent · {{seats}} seat",
  },
  suspend: {
    action: "I-suspend ang tenant",
    title: "I-suspend ang {{tenant}}?",
    description: "Magpapakita ng maintenance message ang widget at web app. Mananatili ang data at puwedeng ibalik ang tenant.",
    reason: "Dahilan",
    reasons: {
      non_payment: "Hindi nagbayad (lampas 14 araw)",
      abuse: "Abuso / paglabag sa acceptable use",
      requested_by_tenant: "Hiniling ng tenant",
      security_incident: "Security incident",
      other: "Iba pa",
    },
    note: "Internal note",
    noteHint: "Makikita lang ng CRUD.IT staff",
    notify: "I-email sa owner ang dahilan at paano maibabalik",
    submit: "I-suspend ang tenant",
    done: "Na-suspend ang tenant · maintenance message na ang ipinapakita ng widget at web app",
  },
  reinstate: {
    action: "Ibalik ang tenant",
    title: "Ibalik ang {{tenant}}?",
    description: "Babalik agad online ang mga agent, widget at web app.",
    submit: "Ibalik",
    done: "Naibalik ang tenant",
  },
  deleteTenant: {
    action: "I-delete ang tenant",
    title: "I-delete ang {{tenant}}?",
    description: "Soft-delete ngayon at permanenteng mabubura pagkalipas ng 30 araw (NPC retention policy). Kakanselahin ang mga aktibong subscription.",
    label: "I-type ang pangalan ng tenant para kumpirmahin",
    submit: "I-delete ang tenant",
    done: "Naka-iskedyul ang pag-delete · mabubura ang data sa loob ng 30 araw maliban kung maibalik",
    superAdminOnly: "Super Admin lang ang puwedeng mag-delete ng tenant",
  },
};
